import React from 'react'
import { CopyButton } from './CopyButton'

interface CodeBlockProps {
  children: string
  maxHeight?: number
  fontSize?: string
  showCopy?: boolean
  style?: React.CSSProperties
}

export const CodeBlock: React.FC<CodeBlockProps> = ({
  children,
  maxHeight,
  fontSize = '0.72rem',
  showCopy = true,
  style,
}) => (
  <div style={{ position: 'relative' }}>
    <pre style={{
      margin: 0,
      fontSize,
      background: 'var(--bg-elevated)',
      border: '1px solid var(--border)',
      borderRadius: 8,
      padding: showCopy ? '0.65rem 0.65rem 0.65rem 0.65rem' : '0.65rem',
      paddingTop: showCopy ? '2.2rem' : '0.65rem',
      overflowX: 'auto',
      overflowY: maxHeight ? 'auto' : undefined,
      maxHeight,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      lineHeight: 1.6,
      color: 'var(--text-primary)',
      fontFamily: 'var(--font-mono, monospace)',
      ...style,
    }}>
      {children}
    </pre>
    {showCopy && (
      <div style={{ position: 'absolute', top: '0.4rem', right: '0.4rem' }}>
        <CopyButton text={children} small />
      </div>
    )}
  </div>
)
